export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manawp.9fb6c4ec.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};